<template>
  <l-map
    :zoom.sync="zoom"
    :center="center"
    style="height: 500px; width: 100%"
    ref="mapaUnidadeDeSaude"
    :options="{ zoomControl: false }"
  >
    <l-tile-layer :url="url" :attribution="attribution" />
    <l-control-zoom position="bottomright"></l-control-zoom>

    <!-- <template v-for="item in dadosDoMapa">
          <div :key="item.key">
            <l-circle-marker
              :lat-lng="[item?.latitude, item?.longitude]"
              :radius="getRadiusMarker(item)"
              :color="getRadiusColor(item)"
              :fillColor="getRadiusColor(item)"
              :stroke="false"
              :fillOpacity="0.6"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  direction: 'center',
                  className: 'map-radius',
                  interactive: true,
                }"
              >
                {{ item?.denominador }}
              </l-tooltip>
              <l-popup>
                <div class="tooltip-latlgn">
                  <span> UBS: {{ item?.no_ubs }}</span>
                  <br />
                  <span>
                    CNES + INE: {{ item?.cnes }} | {{ item?.ine }} |
                    {{ item?.tipo_equipe }}</span
                  >
                  <br />
                  <span> PARÂMETRO: {{ item?.min_cad }} pessoas </span>
                  <br />
                  <span>
                    CADASTROS e-SUS: {{ item?.denominador }} pessoas
                  </span>
                  <br />
                  <span> MÁXIMO: {{ item?.max_cad }} pessoas </span>
                  <br />
                  <div class="mt-2">
                    <span
                      ><strong>ATENÇÃO!</strong>
                      <br />
                      {{ item.recomendacao_cadastro }}</span
                    >
                  </div>
                </div>
              </l-popup>
            </l-circle-marker>
          </div>
        </template> -->
  </l-map>
</template>

<script>
import * as Functions from './functions.js'
import { coordinates } from '@/pages/PrevineBrasil/coordinates'
import mapa from '@/pages/PrevineBrasil/arquivos/mapa_ranking_regional'
import {
  LMap,
  LCircle,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LPopup,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet.markercluster/dist/leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

export default {
  components: {
    LMap,
    LCircle,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    LPopup,
    LMarkerCluster: L.markerClusterGroup,
  },
  props: {
    dadosResultado: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      zoom: 10,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      dadosDoMapa: [],
    }
  },
  methods: {
    initMap() {
      this.dadosDoMapa = this.dadosResultado.filter((item) => {
        return item.indicador == '0' && item.latitude !== null
      })
      setTimeout(() => {
        const cod_ibge = this.$store.state.cod_ibge
        const state = this.$store.state.cidade.split('-')[1].trim()

        // pega as coordenadas do municipio
        const countyCoordinates = mapa.find((item) => {
          return item.co_ibge === cod_ibge
        })

        // pega o zoom para o estado
        const coordinatesState = coordinates.find((item) => {
          return item.uf === state
        })
        const mapObject = this.$refs.mapaUnidadeDeSaude.mapObject

        mapObject.invalidateSize(true)
        mapObject.setView(
          latLng(countyCoordinates.local[0], countyCoordinates.local[1]),
          coordinatesState.zoom + 4
        )

        this.addMarkers()
      }, 500)
    },

    addMarkers() {
      const markerCluster = L.markerClusterGroup()
      const mapObject = this.$refs.mapaUnidadeDeSaude.mapObject
      const markersData = this.dadosDoMapa

      markersData.forEach((data) => {
        if (data.latitude && data.longitude) {
          // const marker = L.marker([data.latitude, data.longitude])
          const marker = L.circleMarker([data.latitude, data.longitude], {
            radius: Functions.getRadius(data),
            color: Functions.getRadiusColor(data),
            fillColor: Functions.getRadiusColor(data),
            stroke: false,
            fillOpacity: 0.6,
          })

          const popupContent = `
            <div class="tooltip-latlgn">
              <span>UBS: ${data.no_ubs}</span><br />
              <span>CNES + INE: ${data.cnes} | ${data.ine} | ${data.tipo_equipe}</span><br />
              <span>PARÂMETRO: ${data.min_cad} pessoas</span><br />
              <span>CADASTROS e-SUS: ${data.denominador} pessoas</span><br />
              <span>MÁXIMO: ${data.max_cad} pessoas</span><br />
              <div class="mt-2">
                <span><strong>ATENÇÃO!</strong><br />${data.recomendacao_cadastro}</span>
              </div>
            </div>
          `

          // Adicionar tooltip permanente com as opções fornecidas
          marker
            .bindTooltip(data.denominador, {
              permanent: true,
              direction: 'center',
              className: 'map-radius',
              interactive: true,
            })
            .openTooltip()

          // Adicionar evento de mouseover para mostrar o popup
          marker.on('mouseover', function () {
            marker.bindPopup(popupContent).openPopup()
          })

          // Adicionar evento de mouseout para fechar o popup
          marker.on('mouseout', function () {
            marker.closePopup()
          })

          markerCluster.addLayer(marker)
        }
      })

      mapObject.addLayer(markerCluster)
    },

    getRadiusMarker(item) {
      return Functions.getRadius(item)
    },

    getRadiusColor(item) {
      return Functions.getRadiusColor(item)
    },
  },
}
</script>

<style></style>
